module.exports = __webpack_public_path__ + "static/media/rainier.5b4edbf4.jpg";